import * as React from "react";
const SvgAlertCircle = (props) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      clipPath="url(#alert-circle_svg__a)"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M6 11A5 5 0 1 0 6 1a5 5 0 0 0 0 10ZM6 4v2M6 8h.005" />
    </g>
    <defs>
      <clipPath id="alert-circle_svg__a">
        <path fill="currentColor" d="M0 0h12v12H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgAlertCircle;
